import request from '@/utils/request'

export function getBitList(query) {
  return request({
    url: '/api/v1/bit/bit',
    method: 'get',
    params: query
  })
}

export function getBitFavoriteList(query) {
  return request({
    url: '/api/v1/bit/favorite',
    method: 'get',
    params: query
  })
}

export function getBitDetail(id) {
  return request({
    url: '/api/v1/bit/bit/detail/' + id,
    method: 'get',
  })
}

export function getBitSettingList(query) {
  return request({
    url: '/api/v1/bit/setting-list',
    method: 'get',
    params: query
  })
}

export function getBitSettingDetail(id) {
  return request({
    url: '/api/v1/bit/bit/setting-detail/' + id,
    method: 'get',
  })
}

export function getDataList(query) {
  return request({
    url: '/api/v1/bit/bit/data',
    method: 'get',
    params: query
  })
}

export function getKDataList(id, param) {
  return request({
    url: '/api/v1/bit/bit/kdata/' + id,
    method: 'get',
    params: param
  })
}

export function getDepthList(id) {
  return request({
    url: '/api/v1/bit/bit/depth/' + id,
    method: 'get',
  })
}

export function getContractList(query) {
  return request({
    url: '/api/v1/bit/contract',
    method: 'get',
    params: query
  })
}

export function getContractSetting(id) {
  return request({
    url: '/api/v1/bit/contract/' + id,
    method: 'get',
  })
}

export function getContractOrder(id) {
  return request({
    url: '/api/v1/bit/contract/detail' + id,
    method: 'get',
  })
}

export function getCoinList(query) {
  return request({
    url: '/api/v1/bit/coin',
    method: 'get',
    params: query
  })
}

export function getCoinSetting(id) {
  return request({
    url: '/api/v1/bit/coin/' + id,
    method: 'get',
  })
}

export function getCoinOrder(id) {
  return request({
    url: '/api/v1/bit/coin/detail' + id,
    method: 'get',
  })
}

export function getOptionsList(query) {
  return request({
    url: '/api/v1/bit/options',
    method: 'get',
    params: query
  })
}

export function getOptionsSetting(id) {
  return request({
    url: '/api/v1/bit/options/' + id,
    method: 'get',
  })
}

export function getOptionsOrder(id) {
  return request({
    url: '/api/v1/bit/options/detail/' + id,
    method: 'get',
  })
}

export function createContract(data) {
  return request({
    url: '/api/v1/bit/contract/create',
    method: 'post',
    data
  })
}

export function cancelContract(data) {
  return request({
    url: '/api/v1/bit/contract/cancel',
    method: 'post',
    data
  })
}

export function confirmContract(data) {
  return request({
    url: '/api/v1/bit/contract/close',
    method: 'post',
    data
  })
}

export function createCoin(data) {
  return request({
    url: '/api/v1/bit/coin/create',
    method: 'post',
    data
  })
}

export function cancelCoin(id) {
  return request({
    url: '/api/v1/bit/coin/cancel/' + id,
    method: 'post',
  })
}

export function confirmCoin(data) {
  return request({
    url: '/api/v1/bit/coin/confirm',
    method: 'post',
    data
  })
}

export function createOptions(data) {
  return request({
    url: '/api/v1/bit/options/create',
    method: 'post',
    data
  })
}

export function getMinerList(query) {
  return request({
    url: '/api/v1/bit/miner',
    method: 'get',
    params: query
  })
}

export function getMinerDetail(id) {
  return request({
    url: '/api/v1/bit/miner/' + id,
    method: 'get',
  })
}

export function getMinerOrderList(query) {
  return request({
    url: '/api/v1/bit/miner/order',
    method: 'get',
    params: query
  })
}

export function getMinerOrderCensus(query) {
  return request({
    url: '/api/v1/bit/miner/order/census',
    method: 'get',
    params: query
  })
}

export function createMinerOrder(data) {
  return request({
    url: '/api/v1/bit/miner/order/create',
    method: 'post',
    data
  })
}

export function updateMinerOrder(data) {
  return request({
    url: '/api/v1/bit/miner/order/break',
    method: 'post',
    data
  })
}

export function createFavorite(data) {
  return request({
    url: '/api/v1/bit/favorite/create',
    method: 'post',
    data
  })
}

export function updateFavorite(data) {
  return request({
    url: '/api/v1/bit/favorite/update',
    method: 'post',
    data
  })
}
